require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./albina-killingsworth-collaboration.json") })
        }
      }, "path---albina-killingsworth-collaboration");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---albina-killingsworth-collaboration!./.cache/json/albina-killingsworth-collaboration.json
// module id = 838
// module chunks = 231608221292675